import request from "@/utils/request";  //导入封装请求的js文件




export function getVarGoToken(data) {
  return request({
    // url: "/system/JingshuhomeController/getVarGoToken/"+params,  //接口路径
    // method: "get",  //接口方法
    // // params:params
    url: "/prod-api/system/JingshuhomeController/getVarGoToken",
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  });
}
//获取认证
export function getInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getInfo",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

//获底部导航栏
export function homeBottom(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/homeBottom",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}




// 获取全国地址
export function regionList(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/regionList",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}
// 获取类目数据
export function treeselect(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/treeselect",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}



//获取首页页面数据
export function homeIndex(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/homeIndex",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

//获取对应类目详情
export function getCategoryInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getCategoryInfo/"+params,  //接口路径
    method: "get",  //接口方法
  });
}

// 定制服务
export function customList() {
  return request({
    url: "/prod-api/system/JingshuhomeController/customList",  //接口路径
    method: "get",  //接口方法
  });
}

//获取私人定制服务
export function getCustomList(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getCustomList",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

// 定制需求
export function addCustomDemand(data) {
  return request({
    url: "/prod-api/system/JingshuhomeController/addCustomDemand",
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  });
}
//验证码
export function captchaImage(params) {
  return request({
    url: "/prod-api/captchaImage",  //接口路径
    method: "get",  //接口方法
  });
}

//验证码
export function afterSalesInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/afterSalesInfo",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

// 获取对应通用模版数据
export function getTypeDetails(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getTypeDetails",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}


//获取对应新闻详情
export function getGeneralDetailsInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getGeneralDetailsInfo/"+params,  //接口路径
    method: "get",  //接口方法
  });
}


// 获取新闻中心列表数据
export function getNewsCenterList(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getNewsCenterList",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

export function recruitingTalents() {
  return request({
    url: "/prod-api/system/JingshuhomeController/recruitingTalents",  //接口路径
    method: "get",  //接口方法
  });
}

// 地址省市
export function regionNotCountyList() {
  return request({
    url: "/prod-api/system/JingshuhomeController/regionNotCountyList",  //接口路径
    method: "get",  //接口方法
  });
}

// 岗位列表
export function positionList(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/positionList",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

// 岗位详情
export function jingshJobInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/JingshJobInfo/"+params,  //接口路径
    method: "get",  //接口方法
  });
}

// 岗位下拉数据
export function jobTypeList(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/jobTypeList",  //接口路径
    method: "get",  //接口方法
  });
}

// 成为合作伙伴
export function addCollaboration(data) {
  return request({
    url: "/prod-api/system/JingshuhomeController/addCollaboration",
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  });
}
// 全局搜索
export function searchList(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/searchList",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

// 服务支持 在线报修 售后政策
export function serviceSupportsInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/serviceSupportsInfo/"+params,  //接口路径
    method: "get",  //接口方法
  });
}



// 项目需求咨询
export function addProjectDemand(data) {
  return request({
    url: "/prod-api/system/JingshuhomeController/addProjectDemand",
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  });
}

// 发送验证码
export function sendCode(data) {
  return request({
    url: "/prod-api/common/sendCode",
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  });
}


//产品 Emm系统数据
export function getEmmSystem() {
  return request({
    url: "/prod-api/system/JingshuhomeController/getEmmSystem",  //接口路径
    method: "get",  //接口方法
  });
}
//产品 京数云系统数据
export function getCloudSystem() {
  return request({
    url: "/prod-api/system/JingshuhomeController/getCloudSystem",  //接口路径
    method: "get",  //接口方法
  });
}
//产品 移动办公系统数据
export function getMobileOfficeSystem() {
  return request({
    url: "/prod-api/system/JingshuhomeController/getMobileOfficeSystem",  //接口路径
    method: "get",  //接口方法
  });
}
//产品 端 管 云 数据
export function getEndPipeCloud(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/getEndPipeCloud",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}

export function geMenuDetailsInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/geMenuDetailsInfo/"+params,  //接口路径
    method: "get",  //接口方法
  });
}

//在线报修
export function reportForRepair(data) {
  return request({
    url: "/prod-api/system/JingshuhomeController/reportForRepair",  //接口路径
    method: "post",  //接口方法
    headers: { 'Content-Type': 'application/json' },
    transformRequest: [function (data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  });
}

// 报修查询
export function repairInfo(params) {
  return request({
    url: "/prod-api/system/JingshuhomeController/repairInfo",  //接口路径
    method: "get",  //接口方法
    params: params
  });
}



































